<template>
  <div class="MallIndex">
    <div class="swiperBox">
      <el-carousel height="500px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img class="banner" :src="item.url" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="notice-bar" v-if="noticeBar && noticeBar.length > 0">
      <div>{{ noticeBar[0]['7mhpyoswctp8w2ko'] }}</div>
      <!-- <marquee behavior="scroll" scrollamount="1" direction="up" loop="-1">
        <span v-for="item in noticeBar" :key="item.id">
          {{ item['7mhpyoswctp8w2ko'] }}
        </span>
      </marquee> -->
    </div>
    <section class="recommendedGoods section">
      <SectionHeader title="产品推荐" />
      <ul class="goodsList" slot="list">
        <GoodsItem
          v-for="(item, index) in goodsList"
          :key="index"
          :id="item.id"
          :img="
            item.rguiigpafo0pe0my && item.rguiigpafo0pe0my.length > 0
              ? item.rguiigpafo0pe0my[0].url
              : ''
          "
          :name="item.avdrlfwlhg7kywxn"
          :price="item.f93blbqlvdtdt65v"
          :section="item.dzornqdwofgytboq"
          :sku="item.levmoblohezp7y50"
        />
      </ul>
    </section>
  </div>
</template>

<script>
// import {getTypes,getGoodsList} from '../../api/client';
import SectionHeader from "../../components/SectionHeader";
import ZoomImg from "../../components/ZoomImg";
import GoodsItem from "../../components/GoodsItem";
import Slick from "../../components/Slick";
import FadeSwiper from "../../components/FadeSwiper";
import { online, getUToken } from "@/api/platform";
export default {
  name: "MallIndex",
  components: {
    SectionHeader,
    ZoomImg,
    GoodsItem,
    Slick,
    FadeSwiper,
  },
  computed: {
  },
  data () {
    return {
      typeList: [],
      goodsList: [],
      initTimestamp: 0,
      newTimestamp: 0,
      timer: null,
      h: 0,
      m: 0,
      s: 0,
      clientWidth: "",
      bannerList: [],
      form_head_uuid: "b39c66e39ef54c5ba5925f692af96e69",
      hierarchyList: [],
      props: {
        value: 'id',
        label: 'bvnmpzigqwuyexo7',
        expandTrigger: 'hover'
      },
      noticeBar: []
    };
  },
  async mounted () {
    console.log(this.$store.state);
    const { clientToken } = this.$store.state
    console.log(111);
    if (clientToken) {
      await this.banner();
      await this.getNoticeBar();
      await this.getHierarchyList()
      await this.getRecommendedProducts();
    } else {
      this.$router.push('/login');
    }
  },

  methods: {
    // async getUToken () {
    //   const { result } = await getUToken({
    //     applicationId: '270ab0c29e5411ee9b8b0242321230b4',
    //     appkey: '3d8a7459b781c2cc637eddf020ce7f5c',
    //     appsecret: '4886eaa91e7a7412d384a1042064cc74',
    //     username: '19988888888',
    //   })
    //   this.$store.commit('setData', {
    //     temporarilyToken: result.token, // 临时token
    //   });
    // },
    async getHierarchyList () {
      const { result } = await online({
        form_head_uuid: '850556846c4643ebbd8c24741481c3e0'
      })
      this.hierarchyList = result
    },
    filterGoodsByType (typeid) {
      return this.goodsList.filter((item) => {
        return item.typeId === typeid;
      });
    },
    navTo (route) {
      this.$router.push(route);
    },
    selectType (typeId) {
      if (typeId == -1) {
        return;
      }
      this.navTo("/mall/show/goodsList/" + typeId + "/all");
    },
    async getNoticeBar () {
      const { result } = await online({
        form_head_uuid: 'bf7a80f39ecf4ae1b19bffb4f299e925',
        page: 1,
        limit: 20,
        keyword: "",
        select_option: "",
      });
      this.noticeBar = result
    },
    // 获取banner图
    async banner () {
      const { result } = await online({
        page: 1,
        limit: 20,
        form_head_uuid: "12b59f8a4698486784979d7416071d3e",
      });
      if (result.length > 0) {
        this.bannerList = result.map((el) => el["8dzgbn9fg4vlyagl"][0]);
      }
    },

    // 推荐商品
    async getRecommendedProducts () {
      const { form_head_uuid } = this;
      const { result } = await online({
        page: 1,
        limit: 20,
        keyword: "",
        select_option: "",
        form_head_uuid,
      });
      this.goodsList = result;
    },
    searchTip (tip) {
      alert(tip);
    },
    inputTextChange (text) { },
    scrollHandle () {
      const top = this.$refs.typeList.getBoundingClientRect().top;
      //还未到顶
      if (top > 0) {
        this.navShouldFixed = false;
      } else {
        //已经到顶
        this.navShouldFixed = true;
      }
    },
    handleItem ({ id }) {
      this.navTo(`/mall/show/goodsList/1/all?id=${id}`);
    },
    navTo (route) {
      this.$router.push(route);
    },
  },

  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.MallIndex {
  width: 100%;
  .swiperBox {
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
    .banner {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .el-carousel {
      flex: 1;
    }
    .cascader {
      width: 220px;
      height: 500px;
      position: relative;
      border: 1px solid #e4e4e4;
      overflow-y: auto;
      background: #ffffff;
      overflow-x: hidden;
      /deep/.el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .cascader-panel {
        height: 36px;
        line-height: 36px;
        padding-left: 16px;
        padding-right: 10px;
        box-sizing: border-box;
        font-size: 14px;
        color: #3e3f42;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 5px;
        }
      }
    }
  }
  .notice-bar {
    // min-height: 50px;
    margin-top: 20px;
    padding: 10px 12px;
    background-color: #fff;
    color: #333333;
    font-size: 14px;
    box-sizing: border-box;
    // font-weight: bold;
    /deep/.el-carousel__container {
      height: auto;
      min-height: 30px;
    }
    .el-carousel__item {
      height: auto;
      display: flex;
      align-items: center;
    }
  }
  .section {
    padding: 20px 0;
    overflow: hidden;
    .Slick {
      position: relative;
      left: -20px;
    }
  }
  .goodsList {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fill, 232px);
  }
  .newGoods {
    // margin-top: 440px;
  }
  .recommendedGoods {
    // margin-top: 440px;
  }
  .flashSale {
    .content {
      border: 1px solid @borderColor;
      height: 376px;
      position: relative;
      .left {
        vertical-align: top;
        display: inline-block;
        width: 20%;
        height: 100%;
        position: relative;
        background-image: url(//yanxuan.nosdn.127.net/c9aeb62a3f79123d793d8c49b6698b09.jpg);
        background-repeat: no-repeat;
        background-size: 100%;
        text-align: center;
        color: #615548;
        cursor: pointer;
        .title {
          font-size: 26px;
          font-weight: 500;
          margin-top: 60px;
        }
        hr {
          width: 20px;
          height: 2px;
          background-color: #615548;
          border: none;
          margin-top: 20px;
        }
        .tips {
          font-size: 18px;
          margin-top: 20px;
        }
        .countBox {
          margin-top: 20px;
          .time {
            width: 42px;
            height: 42px;
            line-height: 42px;
            font-size: 19px;
            display: inline-block;
            color: white;
            background-color: #615548;
          }
        }
        .allBtn {
          width: 110px;
          height: 33px;
          line-height: 33px;
          font-size: 13px;
          background-color: #a7936e;
          color: white;
          border-radius: 20px;
          margin: 50px auto;
        }
      }
      .right {
        vertical-align: top;
        display: inline-block;
        width: 80%;
        height: 100%;
        position: relative;
        overflow: hidden;
        li {
          display: inline-block;
          width: 50%;
          height: 50%;
          overflow: hidden;
          .leftImg {
            width: 180px;
            height: 100%;
            display: inline-block;
          }
          .rightBox {
            display: inline-block;
            width: 240px;
            height: 100%;
            overflow: hidden;
            .goodsName {
              font-size: 15px;
              cursor: pointer;
              margin-top: 16px;
              &:hover {
                color: @thirdColor;
              }
            }
            .less {
              margin-top: 16px;
              .lessBar {
                display: inline-block;
                width: 150px;
                height: 10px;
                background-color: #ffe5e5;
                border: 1px solid #f2cecd;
                border-radius: 10px;
              }
              .lessNum {
                color: @fontDefaultColor;
                font-size: 13px;
              }
            }
            .price {
              margin-top: 16px;
              .nowPrice {
                color: @falseColor;
                font-size: 20px;
              }
              .beforePrice {
                color: @fontDefaultColor;
                text-decoration: line-through;
                margin-left: 10px;
                font-size: 14px;
              }
            }
            .buyBtn {
              margin-top: 16px;
              width: 120px;
              height: 30px;
              color: white;
              background-color: @falseColor;
              text-align: center;
              line-height: 30px;
              cursor: pointer;
            }
          }
          &:nth-of-type(1) {
            border-bottom: 1px solid @borderColor;
            border-right: 1px solid @borderColor;
          }
          &:nth-of-type(2) {
            border-bottom: 1px solid @borderColor;
          }
          &:nth-of-type(3) {
            border-right: 1px solid @borderColor;
          }
        }
      }
    }
  }
  .maker {
    .content {
      .left,
      .center,
      .right {
        display: inline-block;
        height: 320px;
        width: 32%;
      }
      .left,
      .center {
        margin-right: 7px;
        .makerInfo {
          p {
            text-align: center;
          }
          hr {
            width: 60px;
          }
          .large {
            margin-top: 50px;
            margin-bottom: 10px;
            font-size: 26px;
          }
          .small {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }
      .right {
        .ZoomImg {
          width: 100%;
          height: 49%;
          .makerInfo {
            p {
              text-align: left;
              margin-left: 30px;
            }
            hr {
              width: 60px;
              position: relative;
              left: -122px;
            }
            .large {
              margin-top: 30px;
              margin-bottom: 10px;
              font-size: 20px;
            }
            .small {
              margin-top: 10px;
              font-size: 12px;
            }
          }
          &:first-child {
            margin-bottom: 7px;
          }
        }
      }
    }
  }
  .hotGoods {
    background-color: rgb(244, 240, 234);
    height: 654px;
    .left {
      width: 394px;
      display: inline-block;
      vertical-align: top;
      .GoodsItem {
        width: 100%;
        height: 532px;
        background-color: white;
      }
      .GoodsItem /deep/ .imgBox {
        height: 380px;
      }
      .GoodsItem /deep/ .goodsInfo {
        height: auto;
      }
      .GoodsItem /deep/ .goodsName {
        font-size: 30px;
        line-height: 60px;
      }
    }
    .right {
      display: inline-block;
      vertical-align: top;
      width: 740px;
      height: 100%;
      .GoodsItem {
        width: 230px;
        height: 260px;
        background-color: white;
        margin-left: 10px;
        overflow: hidden;
      }
      .GoodsItem /deep/ .imgBox {
        height: 180px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/MallIndex.vue